export default __webpack_public_path__ + "static/media/About-Tower-viajes-1@3x.0ddc854c.jpg";